import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEmpPastActivities, getMember } from '../../../redux/MainAction';
import Aux from '../../../hoc/Aux_';
import PaginationComponent from '../filters/PaginationComponent';
import moment from 'moment';
import MapModal from '../Monitoring/Activity/MapModal';

const PastActivities = () => {
  const dispatch = useDispatch();
  const pastActivities = useSelector(
    (state) => state.Webtracker.employeePastActivities
  );

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 10;

  useEffect(() => {
    getList();
  }, [page]);

  const getList = () => {
    var data = {
      offset: (page - 1) * itemsPerPage,
      limit: itemsPerPage,
    };
    dispatch(
      getEmpPastActivities({
        ownerId: localStorage.getItem('ownerId'),
        ...data,
      })
    );
  };

  useEffect(() => {
    setTotalPages(Math.ceil(pastActivities.count / itemsPerPage));
  }, [pastActivities]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const TEXT_COLORS = ['#1e40af', '#16a34a', '#0d9488', '#dc2626'];

  return (
    <Aux>
      <div className="page-content-wrapper chat-box-container">
        <div className="container-fluid p-3 mb-4">
          <table
            id="datatable"
            className="table dt-responsive nowrap table-vertical"
            width="100%"
            cellSpacing="0"
          >
            <thead>
              <tr className="bg-gray-100">
                <th>Project</th>
                <th>Task</th>
                <th className="text-center">Start Time</th>
                <th className="text-center">End Time</th>
                <th className="text-center">Duration ( in min. )</th>
                <th className="text-center">Mouse Clicks</th>
                <th className="text-center">Keystroke</th>
                <th className="text-center">Scroll Count</th>
                <th className="text-center">Idle Minutes</th>
                <th>Activity Start Location</th>
              </tr>
            </thead>

            <tbody>
              {pastActivities && pastActivities?.rows?.length > 0 ? (
                pastActivities?.rows?.map((activity) => (
                  <tr key={activity.id} style={{ fontSize: '15px' }}>
                    <td>{activity.projectTask?.name}</td>

                    <td className="whitespace-nowrap">
                      {activity.projectTask?.project?.name}
                    </td>

                    <td className="px-3 py-2 text-nowrap text-center">
                      {activity.startTime ? (
                        <>
                          {moment(activity.startTime).format('hh:mm A')}
                          <br />
                          {moment(activity.startTime).format('DD MMM, YYYY')}
                        </>
                      ) : (
                        '-'
                      )}
                    </td>

                    <td className="px-3 py-2 text-nowrap text-center">
                      {activity.endTime ? (
                        <>
                          {moment(activity.endTime).format('hh:mm A')}
                          <br />
                          {moment(activity.endTime).format('DD MMM, YYYY')}
                        </>
                      ) : (
                        '-'
                      )}
                    </td>

                    <td className="px-3 py-2 text-nowrap text-center">
                      {Number(activity.totalTime / 60).toFixed(2)}
                    </td>

                    <td
                      className="px-3 py-2 text-nowrap text-center"
                      style={{ color: TEXT_COLORS[0] }}
                    >
                      {activity.mouseClick}
                    </td>

                    <td
                      className="px-3 py-2 text-nowrap text-center"
                      style={{ color: TEXT_COLORS[1] }}
                    >
                      {activity.keystroke}
                    </td>

                    <td
                      className="px-3 py-2 text-nowrap text-center"
                      style={{ color: TEXT_COLORS[2] }}
                    >
                      {activity.scroll}
                    </td>

                    <td
                      className="px-3 py-2 text-nowrap text-center"
                      style={{ color: TEXT_COLORS[3] }}
                    >
                      {Number(activity.idleTime / 60).toFixed(2)}
                    </td>

                    <td className="px-4 py-3 whitespace-nowrap text-sm font-bold text-right">
                      <MapModal
                        acts={{
                          longitude: activity?.longitude,
                          latitude: activity?.latitude,
                          city: activity?.city,
                        }}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <PaginationComponent
            count={totalPages}
            page={page}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </Aux>
  );
};

export default PastActivities;
